import React from 'react'
import { FaMinus } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type RemoveFromShapeControlProps = {
  onClick: () => void
  disabled?: boolean
}

const RemoveFromShapeControl = ({ onClick, disabled }: RemoveFromShapeControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (disabled) return
    onClick()
  }

  return (
    <div className={cn('control', 'remove-from-shape')} data-graph-type="control" title="Remove from shape">
      <a className={cn('icon', { disabled })} onClick={handleClick}>
        <FaMinus aria-hidden />
        <span className="sr-only">Remove from shape</span>
      </a>
    </div>
  )
}

export default RemoveFromShapeControl
